import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'core/components';
import { useAgGridTableContext } from 'core/states';
import { Color, Variant } from 'theme/enums';

import { ChangeContactGrouping } from './ChangeContactGrouping';

interface IProps {
  onSubmitSuccess?: () => void;
}

export const ChangeContactGroupingButton = ({ onSubmitSuccess }: IProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  const { selectedRows } = useAgGridTableContext();

  return (
    <>
      <Button
        text={t('buttonLabelChangeContactGrouping')}
        color={Color.NEUTRAL}
        variant={Variant.OUTLINED}
        onClick={() => setIsOpen(true)}
        disabled={selectedRows.length === 0}
      />

      <ChangeContactGrouping
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onSubmitSuccess={onSubmitSuccess}
      />
    </>
  );
};
